/// <amd-module name="Wit/Common/WorkItemDialogs/Components/CloneWorkItemDialog" />
import * as React from "react";

import { ITfsProjectService } from "TFS/Services/TfsProjectService";
import { ObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { traceException } from "VSS/Platform/Trace";
import { Dialog } from "VSSUI/Dialog";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { CoreFieldRefNames, DalFields } from "Wit/Common/Generated/Constants";
import * as Resources from "Wit/Common/WorkItemDialogs/Resources";
import { IWorkItemTypesService } from "Wit/Common/WorkItemTypesService/IWorkItemTypesService";
import { INamedFieldDataDictionary } from "Wit/WorkItemDataManager/Contracts";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { IWorkItemModelService } from "Wit/WorkItemModel/Services/IWorkItemModelService";
import { WorkItemFormDialog } from "./WorkItemFormDialog";

export interface ICloneWorkItemDialogProps {
    selectedItem: INamedFieldDataDictionary;
    onDismiss: () => void;
}

export class CloneWorkItemDialog extends VssComponent<ICloneWorkItemDialogProps> {
    private _observable = new ObservableValue<IWorkItem | undefined>(undefined);
    private _error = new ObservableValue<string | undefined>(undefined);

    public constructor(props: ICloneWorkItemDialogProps, context: IVssComponentContext) {
        super(props, context);

        this._initialize();
    }

    private async _initialize() {
        const workItemId = this.props.selectedItem[CoreFieldRefNames.Id] as number;
        try {
            const projectService = this.context.pageContext.getService<ITfsProjectService>("ITfsProjectService");
            const projects = await projectService.getAllProjectsLoadedPromise();
            const modelService = this.context.pageContext.getService<IWorkItemModelService>("IWorkItemModelService");
            const workItemTypeService = this.context.pageContext.getService<IWorkItemTypesService>("IWorkItemTypesService");
            const [source] = await modelService.getWorkItems([workItemId]);
            const project = projects.find(p => p.name === (this.props.selectedItem[CoreFieldRefNames.TeamProject] as string));
            const typeData =
                project &&
                (await workItemTypeService.getWorkItemTypeData(project.id, [this.props.selectedItem[CoreFieldRefNames.WorkItemType] as string]));

            if (project && typeData) {
                const copy = await source.copy(this.context.pageContext, project.id, typeData[0], false, false, false, [DalFields.TitleId]);
                this._observable.value = copy;
            }
        } catch (error) {
            console.error("%O", error);
            this._error.value = error.message || String(error);
            traceException(this.context.pageContext, "WIT", "CloneWorkItem", error, { workItemId });
        }
    }

    public render() {
        return (
            <Observer error={this._error} item={this._observable}>
                {({ error, item }: { error: string | undefined; item: IWorkItem | undefined }) => {
                    if (item) {
                        return <WorkItemFormDialog workItem={item} onDismiss={this.props.onDismiss} />;
                    } else if (error) {
                        return (
                            <Dialog
                                footerButtonProps={[{ text: Resources.OK, onClick: () => this.props.onDismiss() }]}
                                lightDismiss={false}
                                titleProps={{ text: Resources.CloneWorkItemError }}
                                onDismiss={this.props.onDismiss}
                            >
                                {error}
                            </Dialog>
                        );
                    } else {
                        return (
                            <Dialog lightDismiss={false} titleProps={{ text: Resources.CloningWorkItem }} onDismiss={this.props.onDismiss}>
                                <Spinner size={SpinnerSize.large} />
                            </Dialog>
                        );
                    }
                }}
            </Observer>
        );
    }
}
